import type { ReactNode } from 'react';

interface EmptyStateProps {
  message: string;
  icon?: ReactNode;
}

export function EmptyState({ message, icon }: EmptyStateProps) {
  return (
    <div style={{ padding: '60px 20px', textAlign: 'center' }}>
      {icon && <div style={{ marginBottom: '12px', color: '#94a3b8' }}>{icon}</div>}
      <p style={{ color: '#94a3b8', fontSize: '0.9rem', fontStyle: 'italic', margin: 0 }}>
        {message}
      </p>
    </div>
  );
}
